import React, { useEffect, useState } from 'react';
import { Table, Pagination, Form, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

const LuckHist = () => {
    const [luckyEntities, setLuckyEntities] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20); // 한 페이지에 표시할 아이템 수
    const [searchIp, setSearchIp] = useState(''); // 검색할 IP 주소

    useEffect(() => {
        // LuckyEntity 데이터를 가져오는 함수
        const fetchLuckyHistories = async () => {
            try {
                const response = await axios.get(`/api/${process.env.REACT_APP_HISTORY_KEY}`);
                setLuckyEntities(response.data);
            } catch (error) {
                console.error('데이터를 가져오는 데 실패했습니다:', error);
            }
        };

        fetchLuckyHistories();
    }, []);

    // 검색어에 따라 필터링된 데이터
    const filteredEntities = luckyEntities.filter(entity =>
        entity.ip.includes(searchIp)
    );

    // 현재 페이지에 표시할 데이터
    const indexOfLastEntity = activePage * itemsPerPage;
    const indexOfFirstEntity = indexOfLastEntity - itemsPerPage;
    const currentEntities = filteredEntities.slice(indexOfFirstEntity, indexOfLastEntity);

    const totalPages = Math.ceil(filteredEntities.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
    };

    const handleSearchChange = (e) => {
        setSearchIp(e.target.value);
        setActivePage(1); // 검색할 때 첫 페이지로 이동
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setActivePage(1); // 페이지 수 변경 시 첫 페이지로 이동
    };

    return (
        <Container style={{ maxWidth: '800px'}}>
            <Col>
                <h3>전체: <strong>{filteredEntities.length}</strong> 개</h3>
            </Col>
            <Row className="mb-4">
                <Col>
                    <h3 className="text-center text-primary">History</h3>
                </Col>
            </Row>


            {/* IP 검색 필드 */}
            <Form className="mb-3">
                <Form.Group controlId="searchIp">
                    <Form.Label>IP 주소 검색</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="IP 주소 입력"
                        value={searchIp}
                        onChange={handleSearchChange}
                        className="shadow-sm"
                        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()} // Enter 키 막기
                    />
                </Form.Group>
            </Form>

            {/* 페이지당 아이템 수 선택 */}
            <Form.Group controlId="itemsPerPage" className="mb-3">
                <Form.Label>한 페이지에 표시할 항목 수</Form.Label>
                <Form.Control as="select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                    <option value="10">10개</option>
                    <option value="20">20개</option>
                    <option value="30">30개</option>
                    <option value="40">40개</option>
                    <option value="50">50개</option>
                </Form.Control>
            </Form.Group>

            <Table striped bordered hover responsive className="shadow-sm bg-white">
                <thead className="table-primary">
                <tr>
                    <th>#</th>
                    <th>IP 주소</th>
                    <th>디바이스</th>
                    <th>User Agent</th>
                    <th>접속 시간</th>
                </tr>
                </thead>
                <tbody>
                {currentEntities.map((entity, index) => (
                    <tr key={entity.id}>
                        <td>{indexOfFirstEntity + index + 1}</td> {/* 동적 번호 */}
                        <td>{entity.ip}</td>
                        <td>{entity.device}</td>
                        <td>{entity.userAgent}</td>
                        <td>{entity.createdAt}</td>
                    </tr>
                ))}
                </tbody>
            </Table>

            <div className="d-flex justify-content-center mt-4">
                <Pagination className="shadow-sm">
                    <Pagination.Prev onClick={() => handlePageChange(activePage - 1)} disabled={activePage === 1} />
                    {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                            key={index + 1}
                            active={index + 1 === activePage}
                            onClick={() => handlePageChange(index + 1)}
                        >
                            {index + 1}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => handlePageChange(activePage + 1)} disabled={activePage === totalPages} />
                </Pagination>
            </div>
        </Container>
    );
};

export default LuckHist;
